import * as WS from '../webServices/cyMyManager';
type TableAbbonamentiProps = {
    abbonamento: WS.Plus.IF.Abbonamento;
    passToModal: () => void;
};

export default function TableAbbonamenti(props: TableAbbonamentiProps):JSX.Element {
    
    return (
        <tr onClick={props.passToModal} className={"" + (props.abbonamento.tipoAbb === 0 || props.abbonamento.Nome.includes("Crediti") ? ' abb-disabled' : undefined)} >
            <td className='table-cell-mobile'>
                <span className='table-label-mobile' style={{width: 'fit-content'}}>{props.abbonamento.Codice}</span>
                <span className='table-title-mobile'>{props.abbonamento.Nome}</span>
            </td>
        </tr>
    )
}